import {Header, Main, Page} from '@constellation/core';
import {type FC, type ReactNode} from 'react';
import {styled} from 'styled-components';
import PageLevelTagging from '../components/common/Analytics/PageLevelTagging/index.js';
import Footer from '../components/common/Footer/Footer.js';
import getPsrLabel from '../utils/getPsrLabel.js';

type Props = {
  children?: ReactNode;
};

const PageWrapper = styled(Page)`
  background: #ffffff !important;
`;

const PublicLayout: FC<Props> = ({children}) => (
  <PageWrapper>
    <PageLevelTagging />
    <Header data-testid='header' href={getPsrLabel('header.link')} />
    <Main padding='none'>{children}</Main>
    <Footer footerContent={getPsrLabel('footerContent')} />
  </PageWrapper>
);

export default PublicLayout;
